import Icon from '../components/Icon.vue'

Icon.register({"bluetooth-b":{"width":1024,"height":1792,"paths":[{"d":"M596 1423l173-172-173-172v344zM596 713l173-172-173-172v344zM628 896l356 356-539 540v-711l-297 296-108-108 372-373-372-373 108-108 297 296v-711l539 540z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bluetooth-b.js
// module id = 112
// module chunks = 0